import React from 'react';

import GenericMilestoneData from '../shared/GenericMilestoneData';

export default function RevenueMilestoneData(props) {
    return <GenericMilestoneData {...props} />;
}
